import { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';
import { getCompoundEntityRef, parseEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TechDocsAvailability } from 'shared-react';

export function TechDocsReaderAvailability({
  children,
}: PropsWithChildren<{}>) {
  const { namespace = 'default', kind = 'component', name } = useParams();
  if (!name) {
    return <>{children}</>;
  }

  return (
    <TechDocsAvailability entityRef={{ namespace, kind, name }}>
      {children}
    </TechDocsAvailability>
  );
}

export function EntityTechDocsAvailability({
  children,
}: PropsWithChildren<{}>) {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations;
  const externalEntityRef = annotations?.['backstage.io/techdocs-entity'];
  let entityRef = getCompoundEntityRef(entity);
  if (externalEntityRef) {
    try {
      entityRef = parseEntityRef(externalEntityRef);
    } catch {
      return <>{children}</>;
    }
  } else if (!annotations?.['backstage.io/techdocs-ref']) {
    return <>{children}</>;
  }

  return (
    <TechDocsAvailability entityRef={entityRef}>
      {children}
    </TechDocsAvailability>
  );
}
